import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f414498"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "saas-cards-wrap" }
const _hoisted_2 = { class: "saas-cards-block" }
const _hoisted_3 = ["id"]

import {
  card_item,
  card_item_1,
  card_item_2,
  card_item_3,
  card_item_4,
  card_item_5,
  card_item_6,
  HelpModel,
  useLocalizationStore,
} from "@/shared";
import {onBeforeMount, ref} from "vue";
import {BlockCardItem} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'saas-cards',
  setup(__props) {

const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "saas_cards_first_text",
    Title: "saas_interactive_block_first_text",
    Image: card_item_1,
    Id: 1,
    ScrollHash: "digitalwallet"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_second_text",
    Title: "tab_services_solutions_sixth_text",
    Image: card_item,
    Id: 2,
    ScrollHash: "processing"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_third_text",
    Title: "saas_interactive_block_third_text",
    Image: card_item_6,
    Id: 3,
    ScrollHash: "qrpayments"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_fourth_text",
    Title: "saas_interactive_block_fourth_text",
    Image: card_item_5,
    Id: 4,
    ScrollHash: "reporting"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_fifth_text",
    Title: "saas_interactive_block_fifth_text",
    Image: card_item_4,
    Id: 5,
    ScrollHash: "integration"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_sixth_text",
    Title: "saas_interactive_block_sixth_text",
    Image: card_item_3,
    Id: 6,
    ScrollHash: "ecommerce"
  }));
  arrData.value.push(new HelpModel({
    Text: "saas_cards_seventh_text",
    Title: "saas_interactive_block_seventh_text",
    Image: card_item_2,
    Id: 7,
    ScrollHash:"api"
  }));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrData.value, (item, ind) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ind,
          id: item.ScrollHash,
          class: "saas-cards-block-items"
        }, [
          _createVNode(_unref(BlockCardItem), {
            class: _normalizeClass([item.Id%2?'left':'', "saas-content-block-card-item"]),
            image: item.Image,
            text: _unref(translate)(item.Text),
            title: _unref(translate)(item.Title)
          }, null, 8, ["class", "image", "text", "title"])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})